<template>
  <div>
    <form class="topform" @submit="sendMessage($event)">
      <div class="sendMessageContainer">
        <div class="row">
          <div class="col" v-if="phoneNumbers.length === 0">
            <label for="">Kto?</label>
            <select v-model="pickedOption">
              <option
                class="option"
                :value="option.name"
                v-for="option in options"
                :key="option.id"
              >
                {{
                  option.name === "selected_phone_numbers" ||
                  option.name === "date"
                    ? option.displayName
                    : option.displayName + " (" + getCounter(option.name) + ")"
                }}
              </option>
            </select>
          </div>
          <div class="col">
            <label for="">Partnerzy</label>
            <select @change="newPartnersPicked" v-model="pickedOptionPartners">
              <option class="option" :value="'none'">Brak</option>
              <option
                class="option"
                :value="option.id"
                v-for="option in partnersArray"
                :key="option.id"
              >
                {{ option.name + " (" + option.amount + ")" }}
              </option>
            </select>
          </div>
          <!--   MARKETING AGREEMENTS
         <div class="row checkbox-row">
            <input id="check" v-model="marketingAgreement" type="checkbox" />
            <label for="check"
              >Wyślij również do osób bez zgód marketingowych</label
            >
          </div> -->
        </div>
        <div class="addedNumbers">
          <div v-for="partner in pickedPartners" :key="partner.id">
            {{ partner.name }}
            <i
              class="fas fa-times removeNumberIcon"
              @click="deletePartner(partner)"
            ></i>
          </div>
        </div>
        <!-- <div>
          <input
            class="formInputCheck"
            type="radio"
            name="radio"
            @input="setButton('seniors')"
            id="radio1"
            checked
          />
          <label class="form-check-label" for="radio1"> Seniorzy </label>
          <span v-if="userGroupsCounter && userGroupsCounter.seniors">
            ({{ userGroupsCounter.seniors }})
          </span>
        </div>
        <div>
          <input
            class="formInputCheck"
            type="radio"
            name="radio"
            @input="setButton('employees')"
            id="radio2"
          />
          <label class="form-check-label" for="radio2"> Opiekunowie </label>
          <span v-if="userGroupsCounter && userGroupsCounter.employees">
            ({{ userGroupsCounter.employees }})
          </span>
        </div>
        <div>
          <input
            class="formInputCheck"
            type="radio"
            name="radio"
            @input="setButton('employees_accepted')"
            id="radio3"
          />
          <label class="form-check-label" for="radio3">
            Opiekunowie zweryfikowani
          </label>
          <span v-if="userGroupsCounter && userGroupsCounter.employeesAccepted">
            ({{ userGroupsCounter.employeesAccepted }})
          </span>
        </div>
        <div>
          <input
            class="formInputCheck"
            type="radio"
            name="radio"
            @input="setButton('employees_not_finished_payment')"
            id="radio5"
          />
          <label class="form-check-label" for="radio5">
            Opiekunowie z niedokończoną płatnością weryfikacyjną
          </label>
          <span
            v-if="
              userGroupsCounter && userGroupsCounter.employeesNotFinishedPayment
            "
          >
            ({{ userGroupsCounter.employeesNotFinishedPayment }})
          </span>
        </div>
        <div>
          <input
            class="formInputCheck"
            type="radio"
            name="radio"
            @input="setButton('all')"
            id="radio4"
          />
          <label class="form-check-label" for="radio4"> Wszyscy </label>
          <span v-if="userGroupsCounter && userGroupsCounter.all">
            ({{ userGroupsCounter.all }})
          </span>
        </div>
        <div>
          <input
            class="formInputCheck"
            type="radio"
            name="radio"
            @input="setButton('date')"
            id="radio6"
          />
          <label class="form-check-label" for="radio6">
            Zarejestrowani od dnia:
          </label>
        </div> -->
      </div>

      <div
        v-if="pickedOption === 'selected_phone_numbers'"
        class="selectUsersContainerDiv"
      >
        <form @submit.prevent="addOwnNumber">
          <div class="d-flex w-100">
            <input id="addNumbersCheckbox" v-model="ownNumber" />
            <button type="submit" class="btn btn-outline-dark">
              Dodaj numer
            </button>
          </div>
        </form>
      </div>

      <div
        v-if="pickedOption === 'selected_phone_numbers'"
        class="addedNumbers"
      >
        <div v-for="number in this.phoneNumbers" :key="number">
          {{ number }}
          <i
            class="fas fa-times removeNumberIcon"
            @click="deletePhoneNumber(number)"
          ></i>
        </div>
      </div>

      <div class="datepickers" v-if="pickedOption === 'date'">
        <datepicker
          :monday-first="true"
          :language="pl"
          v-model="selectedDateFrom"
          name="dateFrom"
          :placeholder="'Data od'"
        ></datepicker>
      </div>

      <p class="messageContent">
        <label>Wiadomość:</label>
        <textarea
          id="body"
          rows="5"
          maxlength="2048"
          minlength="1"
          class="form-control"
          v-model="message"
          required
          style="width: 100%"
          ref="my_input"
        ></textarea>
        <span class="charsCounter"
          >{{ message.length }}/{{ messageMaxLength }}</span
        >
      </p>
      <div style="margin-top: 10px">
        <input
          type="checkbox"
          id="withoutSmsNotification"
          v-model="with_sms_notification"
          style="margin-right: 5px"
        />
        <label for="withoutSmsNotification">Z powiadomieniem SMS</label>
      </div>

      <button
        :disabled="isSending"
        class="buttonm btn btn-outline-dark"
        type="submit"
      >
        Wyślij
      </button>
    </form>
    <table
      style="margin-top: 40px"
      class="table borderless"
      v-if="this.groupMessages && this.groupMessages.length > 0"
    >
      <thead>
        <tr class="tr-table">
          <th scope="col">Data wysłania</th>
          <th scope="col">Wiadomość</th>
          <th scope="col">Do jakiej grupy?</th>
          <th scope="col">Lista numerów</th>
          <th scope="col">Z powiadomieniem sms?</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="message in groupMessages" :key="message.id">
          <td>
            {{ formattedDate(message.creationDate) }}
          </td>

          <td>{{ message.message }}</td>
          <td>
            {{
              message.userGroup !== "USERS_REGISTERED_FROM_DATE"
                ? translateUserGroup(message.userGroup)
                : `Użytkownicy zarejestrowani od dnia: ${message.dateFrom}`
            }}
          </td>
          <td>
            <button
              v-if="message.userGroup === 'SELECTED_PHONE_NUMBERS'"
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              data-target="#phoneNumbers"
              @click="setAdminNotificationIdToFetchPhoneNumbers(message.id)"
            >
              Lista numerów
            </button>
          </td>
          <td>{{ message.withSmsNotification ? "Nie" : "Tak" }}</td>
        </tr>
      </tbody>
    </table>
    <!-- <p v-if="infoMessage.message" class="text-succes">
      {{ infoMessage.message }}
    </p> -->
    <div
      class="modal fade"
      id="phoneNumbers"
      tabindex="-1"
      role="dialog"
      aria-labelledby="phoneNumbers"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="phoneNumbers">Lista numerów</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="notificationPhoneNumbers.length > 0">
            <span
              v-for="number in notificationPhoneNumbers"
              :key="number"
              style="margin-right: 1rem"
              >{{ number }}
            </span>
          </div>
          <div class="modal-body" v-else>
            <span> Brak </span>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shared from "../../shared";
import Datepicker from "vuejs-datepicker";
import { pl } from "vuejs-datepicker/dist/locale";
import { options } from "./../../utils/optionsWithDate";
import { partners } from "./../../utils/optionsPartners";
import axios from "../../axios";

export default {
  components: { Datepicker },
  name: "send-message",
  computed: {
    users() {
      return this.$store.getters.getUsers;
    },
    infoMessage() {
      return this.$store.getters.getNotificationResponse;
    },
    userGroupsCounter() {
      return this.$store.getters.getUserGroupsCounter;
    },
    groupMessages() {
      return this.$store.getters.getAllGroupMessages;
    },
    phoneNumbersToGroupMessage() {
      return this.$store.getters.getPhoneNumbersToGroupMessages;
    },
    partnersArray() {
      return this.$store.getters.getPartners;
    },
  },
  async created() {
    if (window.localStorage.getItem("phoneNumbersToGroupMessage")) {
      let preChosenNumbers = JSON.parse(
        window.localStorage.getItem("phoneNumbersToGroupMessage")
      );
      this.pickedOption = "selected_phone_numbers";
      preChosenNumbers.forEach((number) => {
        if (
          this.phoneNumbers.length > 0 &&
          !this.phoneNumbers.includes(number)
        ) {
          this.phoneNumbers.push(number);
        } else if (this.phoneNumbers.length === 0)
          this.phoneNumbers.push(number);
      });
      window.localStorage.removeItem("phoneNumbersToGroupMessage");
    }
    this.$store.dispatch("fetchUserGroupsCounter", {});
    this.formattedDate = shared.formattedDate;
    this.fetchAllGroupMessages();
    await this.$store.dispatch("fetchPartners", {});
    const phoneNumbersToGroupMessage = JSON.parse(
      localStorage.getItem("phoneNumbersToGroupMessage")
    );
    if (phoneNumbersToGroupMessage && phoneNumbersToGroupMessage.length > 0) {
      phoneNumbersToGroupMessage.forEach((phone) => {
        this.phoneNumbers.push(phone);
      });
    }
  },

  beforeDestroy() {
    window.localStorage.removeItem("phoneNumbersToGroupMessage");
  },
  data: function () {
    return {
      pl: pl,
      push: false,
      seniors: true,
      employees: false,
      employees_accepted: false,
      employees_not_finished_payment: false,
      all: false,
      singleUser: false,
      dateFrom: false,
      selectedDateFrom: "",
      selectedUser: "",
      message: "",
      messageMaxLength: 2048,
      with_sms_notification: false,
      ownNumber: "",
      phoneNumbers: [],
      pickedOption: "all",
      pickedPartners: [],
      pickedOptionPartners: "none",
      marketingAgreement: false,
      options,
      partners,
      notificationPhoneNumbers: [],
      isSending: false,
    };
  },
  methods: {
    async setAdminNotificationIdToFetchPhoneNumbers(groupMessageId) {
      this.notificationPhoneNumbers = [];
      try {
        const response = await axios.get(
          `/api/groupMessage/${groupMessageId}/phoneNumbers`
        );
        this.notificationPhoneNumbers = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    deletePhoneNumber(number) {
      const index = this.phoneNumbers.indexOf(number);
      if (index !== -1) {
        this.phoneNumbers.splice(index, 1);
      }
    },
    deletePartner(partner) {
      const index = this.pickedPartners.indexOf(partner);
      if (index !== -1) {
        this.pickedPartners.splice(index, 1);
      }
    },
    newPartnersPicked() {
      if (this.pickedOptionPartners === "none") {
        this.pickedPartners = [];
        return;
      }
      this.partnersArray.forEach((partner) => {
        if (partner.id === this.pickedOptionPartners) {
          this.pickedPartners.push({ name: partner.name, id: partner.id });
        }
      });
    },
    getCounter(name) {
      if (this.userGroupsCounter !== null) {
        if (name === "all") return this.userGroupsCounter.all;
        if (name === "seniors") return this.userGroupsCounter.seniors;
        if (name === "employees") return this.userGroupsCounter.employees;
        if (name === "employees_accepted")
          return this.userGroupsCounter.employeesAccepted;
        if (name === "employees_not_finished_payment")
          return this.userGroupsCounter.employeesNotFinishedPayment;
      }
    },
    addOwnNumber() {
      if (this.ownNumber.includes(" ")) {
        this.ownNumber.split(" ").forEach((number) => {
          if (number && number !== "" && !this.phoneNumbers.includes(number)) {
            this.phoneNumbers.push(number);
          }
        });
        this.ownNumber = null;
      } else {
        if (
          this.ownNumber &&
          this.ownNumber !== "" &&
          !this.phoneNumbers.includes(this.ownNumber)
        ) {
          this.phoneNumbers.push(this.ownNumber);
          this.ownNumber = null;
        } else {
          this.ownNumber = null;
        }
      }
    },

    async fetchAllGroupMessages() {
      this.$store.dispatch("fetchAllGroupMessages");
    },
    translateUserGroup(group) {
      if (group === "ALL") {
        return "Wszyscy";
      }
      if (group === "EMPLOYEES") {
        return "Opiekunowie";
      }
      if (group === "EMPLOYEES_ACCEPTED") {
        return "Opiekunowie zweryfikowani";
      }
      if (group === "SENIORS") {
        return "Seniorzy";
      }
      if (group === "EMPLOYEES_NOT_FINISHED_PAYMENT") {
        return "Opiekunowie z niedokończoną płatnością weryfikacyjną";
      }
      if (group === "SELECTED_PHONE_NUMBERS") {
        return "Wybrane numery telefonu";
      }
    },
    async sendMessage(e) {
      try {
        this.isSending = true;
        e.preventDefault();
        let group_type;
        let partnersIDs = [];
        this.pickedPartners.map((partner) => {
          partnersIDs.push(partner.id);
        });
        this.pickedPartners = partnersIDs;
        if (this.pickedOption === "date") {
          if (!this.selectedDateFrom) {
            this.$notify({
              group: "error",
              text: "Wybierz datę",
            });
            return;
          }
          group_type = this.selectedDateFrom;
          group_type = shared.dateWithoutTimeToString(group_type);
        } else {
          group_type = this.pickedOption;
        }

        if (group_type === "selected_phone_numbers") {
          if (this.phoneNumbers.length === 0) {
            this.$notify({
              group: "error",
              text: "Dodaj numery telefonów",
            });
            return;
          }
        }
        if (group_type) {
          const obj = {
            message: this.message,
            group_type: group_type,
            from_admin_panel: true,
            without_sms_notification: !this.with_sms_notification,
            phone_numbers:
              group_type === "selected_phone_numbers" ? this.phoneNumbers : [],
            partners_ids: this.pickedPartners,
            not_required_marketing_agreement: true,
          };

          await this.$store.dispatch("sendMessageToUsers", obj).then(() => {
            this.$notify({
              group: "success",
              text: "Pomyślnie wysłano wiadomość do użytkowników",
            });
            this.phoneNumbers = [];
            this.fetchAllGroupMessages();
          });
        }
        this.pickedPartners = [];
        this.message = "";
        this.selectedDateFrom = "";
      } catch (error) {
        console.log(error);
      } finally {
        this.isSending = false;
      }
    },
    setButton(type) {
      if (type === "seniors") {
        this.seniors = true;
        this.employees = false;
        this.all = false;
        this.singleUser = false;
        this.employees_accepted = false;
        this.employees_not_finished_payment = false;
        this.dateFrom = false;
      }
      if (type === "employees") {
        this.seniors = false;
        this.employees = true;
        this.all = false;
        this.singleUser = false;
        this.employees_accepted = false;
        this.employees_not_finished_payment = false;
        this.dateFrom = false;
      }
      if (type === "employees_accepted") {
        this.seniors = false;
        this.employees = false;
        this.all = false;
        this.singleUser = false;
        this.employees_accepted = true;
        this.employees_not_finished_payment = false;
        this.dateFrom = false;
      }
      if (type === "employees_not_finished_payment") {
        this.seniors = false;
        this.employees = false;
        this.all = false;
        this.singleUser = false;
        this.employees_accepted = false;
        this.employees_not_finished_payment = true;
        this.dateFrom = false;
      }
      if (type === "all") {
        this.seniors = false;
        this.employees = false;
        this.all = true;
        this.singleUser = false;
        this.employees_accepted = false;
        this.employees_not_finished_payment = false;
        this.dateFrom = false;
      }
      if (type === "date") {
        this.seniors = false;
        this.employees = false;
        this.all = false;
        this.singleUser = false;
        this.employees_accepted = false;
        this.employees_not_finished_payment = false;
        this.dateFrom = true;
      }
    },
  },
};
</script>

<style scoped>
.selectUsersContainerDiv button {
  min-width: 0px !important;
  margin-top: 5px !important;
}
.addedNumbers {
  display: flex;
  flex-wrap: wrap;
}
.addedNumbers div {
  border: 1px solid rgb(173, 172, 172);
  padding: 5px;
  margin: 3px;
  border-radius: 50px;
  position: relative;
  min-width: 90px;
  padding-right: 20px;
}
.removeNumberIcon {
  cursor: pointer;
  position: absolute;
  right: 6px;
  top: 8px;
}
div.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
div.input-container {
  flex-direction: column;
  display: flex;
  margin-top: 10px;
}
button.btn {
  margin-top: 20px;
}
.col {
  display: flex;
  flex-direction: column;
  width: 300px;
}
.row {
  display: flex;
}

select {
  padding: 5px;
  background: #fff;
  border: none;
  border-radius: 3px;
  color: #090741;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.option {
  background: #fff;
  color: #090741;
}
.topform {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}
.formInputCheck {
  margin-right: 5px;
}
.pushCheckbox {
  width: 10px;
  margin-right: 10px;
}
.messageContent {
  position: relative;
}
.charsCounter {
  position: absolute;
  bottom: 15px;
  right: 25px;
  font-size: 9px;
}

.input-container,
.messageContent {
  width: 100%;
  min-width: 400px;
}
.sendMessageContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 400px;
}
.topform button {
  min-width: 400px;
}
.message-img {
  width: 100px;
  height: 100px;
}
.checkbox-row label {
  margin-top: 7px;
  margin-left: 15px;
  color: #090741;
  font-size: 13px;
}
.checkbox-row {
  margin-left: 30px;
  margin-top: 15px;
}
</style>
